<svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="16.0001" cy="16.5004" r="12.005" stroke="#2A3243" stroke-width="3.33333" stroke-linecap="round"
    stroke-linejoin="round" />
  <path d="M11.2568 16.9524L14.1474 19.8429L14.1287 19.8242L20.6501 13.3029" stroke="#2A3243" stroke-width="3.33333"
    stroke-linecap="round" stroke-linejoin="round" />
</svg>
